import React from 'react';
import { Box, CardContent, Typography, useTheme } from '@mui/material';
import { ChartsIcon } from '../../../theme/icons';

export const ChannelDetail = (props: {
  title: string;
  value: string;
  unit?: string;
  onClick?: () => void;
  selected?: boolean;
}) => {
  const { title, value, unit, onClick, selected } = props;
  const theme = useTheme();
  const displaySelected = selected !== undefined;
  return (
    <CardContent
      onClick={onClick}
      sx={{
        borderRadius: '2rem',
        backgroundColor:
          !displaySelected || !selected
            ? theme.palette.background.paper
            : theme.palette.primary.main,
        height: '100%',
        padding: '2rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: onClick ? 'pointer' : 'default',
        gap: '0.5rem',
        '&:last-child': {
          paddingBottom: '2rem',
        },
        color:
          !displaySelected || !selected
            ? theme.palette.text.primary
            : theme.palette.primary.contrastText,
      }}
    >
      <Typography
        variant="caption"
        lineHeight={'1rem'}
        color={
          selected
            ? theme.palette.primary.contrastText
            : theme.palette.text.secondary
        }
        textAlign={'center'}
        justifySelf={'start'}
      >
        {title}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="flex-start">
        <Typography
          fontSize={'3rem'}
          color={
            !displaySelected || !selected
              ? theme.palette.text.primary
              : theme.palette.primary.contrastText
          }
        >
          {value}
        </Typography>
        <Typography
          fontSize={'2rem'}
          color={
            !displaySelected || !selected
              ? theme.palette.text.primary
              : theme.palette.primary.contrastText
          }
          lineHeight={'1.95'}
        >
          {unit}
        </Typography>
      </Box>
      {displaySelected ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${theme.palette.secondary.main}`,
            width: '100%',
            borderRadius: '0.5rem',
            padding: '1rem 0.5rem',
            backgroundColor: !selected
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
          }}
          color={
            !selected
              ? theme.palette.primary.main
              : theme.palette.secondary.main
          }
        >
          <ChartsIcon height={'1.5rem'} />
        </Box>
      ) : null}
    </CardContent>
  );
};
